"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtInput = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    &:after{\n        width: 8px;\n    }\n        & .flexi-form-input-extra-label{\n            height: 50%;\n            font-size: 0.8em;\n        }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([" height: ", ";"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    position: relative;\n    border-radius: ", ";\n    ", ";\n    margin: 10px 0;\n    background: #fff;\n    overflow: hidden;\n    ", "\n    & .flexi-form-input-extra-label{\n        position: absolute;\n        height: 100%;\n        display: flex;\n        top:0;\n        left: 0;\n        padding: 20px;\n        align-items: center;\n        transition: ", ";\n        text-transform: uppercase;\n    }\n    & input{\n        position: absolute;\n        background: none;\n        height: 100%;\n        width: 100%;\n        display: block;\n        padding: 20px;\n        border: none;\n        z-index: 2;\n        font-weight: bold;\n        font-size: 1.2em;\n        border-left: 0 solid ", ";\n        color: ", ";\n        &[type=password]{\n            letter-spacing: 1px;\n        }\n        &::placeholder{\n            display: none;\n            color: rgba(0,0,0,0);\n        }\n        &:focus{\n            outline: none;        \n        }\n        &:empty{\n            /* background: silver; */\n        }\n    }\n    &:hover, :focus-within{\n        & .flexi-form-input-extra-label{\n            height: 50%;\n            font-size: 0.8em;\n        }\n    }\n    &:after{\n        display: block;\n        content: '';\n        height: 100%;\n        position: absolute;\n        top:0;\n        left:0;\n        z-index: 1;\n        background: ", ";\n        width: 0;\n        transition: all 0.4s ease-out;\n    }\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ExtInputWrapper = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-form-input-extra'
})(_templateObject(), function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.theme.Elevate.mid;
}, function (props) {
  return props.size && (0, _styledComponents.css)(_templateObject2(), function (props) {
    return props.size;
  });
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.theme.PrimaryColor;
}, function (props) {
  return props.theme.PrimaryFontColor;
}, function (props) {
  return props.theme.PrimaryColor;
}, function (props) {
  return props.value && (0, _styledComponents.css)(_templateObject3());
});

var ExtInput = function ExtInput(props) {
  return /*#__PURE__*/_react["default"].createElement(ExtInputWrapper, props, /*#__PURE__*/_react["default"].createElement("input", props), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-form-input-extra-label"
  }, props.label));
};

exports.ExtInput = ExtInput;
ExtInput.defaultProps = {
  size: '70px'
};
ExtInput.propTypes = {
  size: _propTypes["default"].string,
  label: _propTypes["default"].string
};